module.exports = __webpack_public_path__ + "img/home-circle-1.83f95749.png";